export default {
  statusPublish: 'publish',
  statusDraft: 'draft',
  statusArchive: 'archive',
  statusLabel(status) {
    switch(status) {
      case this.statusPublish:
        return Core.Definition.getDefinition('Publié');
        break
      case this.statusArchive:
        return Core.Definition.getDefinition('Archivé');
        break
      case this.statusDraft:
        return Core.Definition.getDefinition('Brouillon');
        break
      default:
        return ''
        break
    }
  },
  statusOptions(keys) {
    if (keys === undefined) {
      keys = [this.statusPublish, this.statusDraft, this.statusArchive ]
    }
    let options = []
    for(let key in keys) {
      key = keys[key]
      options.push(
          {
            value: key,
            label: this.statusLabel(key)
          }
      )
    }
    return options
  }
}
